import * as React from "react";
import * as S from "@styled";
import { ChangeEvent } from "../../shared/model/Event";
import { EditorProps } from "./EnvironmentVariableEditor";

export class NumberEditor extends React.Component<EditorProps<string>, {}> {

    constructor(props: EditorProps<string>) {
        super(props);
    }

    public shouldComponentUpdate(nextProps: EditorProps<string>) {
        if (nextProps.value !== this.props.value) {
            return true;
        }
        return false;
    }

    public render() {
        return (
            <S.FlexContainer>
                <S.Input
                    placeholder={this.props.value == null ? FRENDS.Localizations.NotSet : undefined}
                    type="number"
                    className="form-control"
                    defaultValue={this.props.value != null ? this.props.value : undefined}
                    onChange={this.handleChange}
                    isFullWidth={true}
                />
            </S.FlexContainer>
        );
    }

    private handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        let value: any = event.target.value;
        if (value != null) {
            value = parseInt(value, 10);
        }
        this.props.updateSingleValue(value, this.props.environmentId);
    }
}
